module.exports = __webpack_public_path__ + "assets/16baf820482b2bb07e065707128e0278.png";